import purchasePackages from "../services/purchase.packages";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        purchasePackages: [],
        members: [],
        purchasePackageDetails: {
            vouchers: [],
            rewards: []
        },
        appHeaderDetails: [],
        appHeader: [],
        topPurchasePackages: [],
        voucherOptions: [],
        rewardOptions: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        membersMaxPage: 1,
        membersNextPage: 0,
        membersPrevPage: 0,
        membersCurrentPage: 1,
        membersTotalPerPage: 1,
        membersCurrentFirstItem: 1,
        membersCurrentLastItem: 1,
        membersInitialPageCount: 0,
        editing: false,
        searching: false,
        errors: null,
        confirmationStatus: false,
        data_errors: null,
        payment_types: []
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        editing(state, value) {
            state.editing = value;
        },
        purchasePackages(state, purchasePackages) {
            state.purchasePackages = purchasePackages;
        },
        setAppHeader(state, appHeader) {
            state.appHeader = appHeader;
        },
        voucherOptions(state, voucherOptions) {
            state.voucherOptions = voucherOptions;
            state.loading = false;
            state.searching = false;
        },
        rewardOptions(state, rewardOptions) {
            state.rewardOptions = rewardOptions;
            state.loading = false;
            state.searching = false;
        },
        topPurchasePackages(state, topPurchasePackages) {
            state.topPurchasePackages = topPurchasePackages;
            state.loading = false;
            state.searching = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        membersPagination(state, membersPagination) {
            state.membersTotalPerPage = membersPagination.list.length;
            state.membersMaxPage = membersPagination.max_page;
            state.membersPrevPage = membersPagination.prev_page;
            state.membersNextPage = membersPagination.next_page;
            state.membersCurrentPage = state.membersPrevPage + 1;
            state.membersCurrentFirstItem =
                state.membersInitialPageCount * state.membersPrevPage + 1;
            state.membersCurrentLastItem =
                state.membersCurrentFirstItem > 0
                    ? state.membersCurrentFirstItem +
                      state.membersTotalPerPage -
                      1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        setMembersInitialPageCount(state, list) {
            state.membersInitialPageCount = list.length;
        },
        setAppHeaderDetails(state, appHeaderDetails) {
            state.appHeaderDetails = appHeaderDetails;
        },
        setDetails(state, details) {
            state.purchasePackageDetails = details;
        },
        members(state, members) {
            state.members = members;
            state.loading = false;
            state.searching = false;
        },
        resetMembersPagination(state) {
            state.membersMaxPage = 1;
            state.membersNextPage = 0;
            state.membersPrevPage = 0;
            state.membersCurrentPage = 1;
            state.membersTotalPerPage = 1;
            state.membersCurrentFirstItem = 1;
            state.membersCurrentLastItem = 1;
            state.membersInitialPageCount = 0;
            state.members = [];
        },
        setConfirmationStatus(state, confirmationStatus) {
            state.confirmationStatus = confirmationStatus;
        },
        setMismatchRows(state, rows) {
            if (rows !== null) {
                state.data_errors = {
                    field_errors: rows.field_errors,
                    mismatch_col: rows.mismatch_col
                };
            } else {
                state.data_errors = rows;
            }
        },
        setPaymentTypes(state, types) {
            state.payment_types = types;
        }
    },
    actions: {
        async getPurchasePackages({ commit }, param) {
            commit("loading");
            commit("purchasePackages", []);
            try {
                let response = await purchasePackages.getPurchasePackages(
                    param
                );

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }

                await commit("purchasePackages", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getTopPurchasePackages({ commit }) {
            commit("loading");
            try {
                let response = await purchasePackages.getTopPurchasePackages();

                for (let index = 0; index < response.list.length; index++) {
                    if (response.list[index].description.length > 100) {
                        response.list[index].description = `${response.list[
                            index
                        ].description.substring(0, 100)}...`;
                    }
                }

                await commit("topPurchasePackages", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async savePurchasePackage({ commit }, param) {
            commit("loading");
            try {
                let response = await purchasePackages.savePurchasePackage(
                    param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Oops, cannot create new purchase package."
                );
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async viewPurchasePackage({ commit }, uuid) {
            commit("loading");
            try {
                let response = await purchasePackages.viewPurchasePackage(uuid);
                // response.price = parseFloat(response.price.replace(/,/g, ''));
                response.model.discount = Math.floor(response.model.discount);
                response.model.vouchers = JSON.parse(response.model.vouchers);
                response.model.rewards = JSON.parse(response.model.rewards);
                if (response.model.card !== null) {
                    response.model.card_placeholder = response.model.card
                        .split("/")
                        .pop();
                } else {
                    response.model.card_placeholder = response.model.card;
                }

                commit("setDetails", response.model);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                console.log(errors);
                commit("loading", false);
            }
        },
        async exportPurchasePackages({ commit }, param) {
            commit("loading");
            try {
                let response = await purchasePackages.exportPurchasePackages(
                    param
                );
                notification.success(
                    "Your data is being exported. You will receive it via email."
                );
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async exportMembers({ commit }, param) {
            commit("loading");
            try {
                let response = await purchasePackages.exportMembers(param);
                notification.success(
                    "Your data is being exported. You will receive it via email."
                );
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getAppHeader({ commit }) {
            commit("loading");
            try {
                let appHeader = await purchasePackages
                    .getAppHeader()
                    .then(response => {
                        return [response.app_header];
                    });
                await commit("setAppHeader", appHeader);
                await commit("setAppHeaderDetails", appHeader[0]);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getVoucherOptions({ commit }, param) {
            commit("loading");
            try {
                let voucherOptions = await purchasePackages
                    .getVoucherOptions()
                    .then(voucher => {
                        return voucher.options.map(option => {
                            return {
                                text: option.name,
                                value: option.uuid
                            };
                        });
                    });
                await commit("voucherOptions", voucherOptions);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getRewardOptions({ commit }, param) {
            commit("loading");
            try {
                let rewardOptions = await purchasePackages
                    .getRewardOptions()
                    .then(rewards => {
                        return rewards.map(reward => {
                            {
                                return {
                                    text: reward.name,
                                    value: reward.uuid
                                };
                            }
                        });
                    });
                await commit("rewardOptions", rewardOptions);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async importCardNos({ commit }, param) {
            commit("loading");
            try {
                let response = await purchasePackages.importCardNos(param);

                let status = response;

                // if (status.message == 'Card IDs successfully imported.' && status.errors.field_errors.length === 0 && status.errors.mismatch_col.length === 0) {
                if (status.message == "Card IDs successfully imported.") {
                    // notification.success(response.message);
                    notification.success("An import is currently in progress.");
                } else if (
                    status.errors.field_errors.length === 0 &&
                    status.errors.mismatch_col.length === 0 &&
                    status.success === 0
                ) {
                    notification.warning(
                        "You have entered an invalid format. Please check the format and try again."
                    );
                } else {
                    await commit("setMismatchRows", status.errors);
                    console.log(status.errors);
                    notification.warning(
                        "You have an invalid field within the csv file. Please check the file and try again."
                    );
                }
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot import package list.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        resetMembersPagination({ commit }) {
            commit("resetMembersPagination");
        },
        async getMembers({ commit }, param) {
            commit("loading");
            commit("members", []);
            try {
                let response = await purchasePackages.getMembers(param);

                if (param.page == 1) {
                    await commit("setMembersInitialPageCount", response.list);
                }

                await commit("members", response.list);
                await commit("membersPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateAppHeader({ commit }, param) {
            commit("loading");
            try {
                let response = await purchasePackages.updateAppHeader(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update package.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updatePurchasePackage({ commit }, data) {
            commit("loading");
            try {
                let response = await purchasePackages.updatePurchasePackage(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update purchase package.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deletePurchasePackage({ commit }, uuid) {
            commit("loading");
            try {
                let response = await purchasePackages.deletePurchasePackage(
                    uuid
                );
                notification.success("Privilege card successfully deleted.");
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Request invalid. There are active cards in use."
                );
                commit("loading", false);
            }
        },
        async confirmAction({ commit }, param) {
            commit("loading");
            try {
                let confirmationStatus = await purchasePackages.confirmAction(
                    param
                );
                if (!confirmationStatus.confirmed) {
                    notification.warning(confirmationStatus.message);
                }
                commit("setConfirmationStatus", confirmationStatus.confirmed);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        fileIsTooBigError({ commit }) {
            commit("errors", {
                errors: {
                    card:
                        "The card background image is too large to upload. The max image file size is 4MB."
                }
            });
        },
        async getPrivilegeCardDetails({ commit }) {
            commit("loading", true);
            try {
              const { data } = await purchasePackages.getPrivilegeCardDetails();
              commit("setPaymentTypes", data.payment_types);
            } catch (errors) {
              commit("errors", errors);
            } finally {
              commit("loading", false);
            }
        },
        async savePrivilegeCardSettings({ commit }, payload) {
            commit("loading", true);
            try {
                const { message, data } = await purchasePackages.savePrivilegeCardSettings(payload);
                commit("setPaymentTypes", data.payment_types);
                notification.success(message);
            } catch (errors) {
                commit("errors", errors.errors);
            } finally {
                commit("loading", false);
            }
        }
    }
};
